document.addEventListener('change', (event) => {
  const sortSelect = event.target.closest('[data-sort-by]');
  if (sortSelect) {
    sortSelect.form?.requestSubmit();
    return;
  }

  const facetInput = event.target.closest('[data-facets-form] input[type="checkbox"]');
  if (facetInput) facetInput.form?.requestSubmit();
});

document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('[data-mobile-facets-close]');
  if (closeButton) closeMobileFacets(closeButton.closest('[data-mobile-facets]'));
});

document.addEventListener('keydown', (event) => {
  const details = document.querySelector('[data-mobile-facets][open]');
  if (!details) return;

  if (event.key === 'Escape') {
    event.preventDefault();
    closeMobileFacets(details);
    return;
  }

  if (event.key !== 'Tab') return;
  const focusable = [
    details.querySelector(':scope > summary'),
    ...details.querySelectorAll('a[href], button:not([disabled]):not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'),
  ].filter((element, index, elements) => element && elements.indexOf(element) === index);
  if (focusable.length === 0) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});

const bindMobileFacets = (scope = document) => {
  scope.querySelectorAll('[data-mobile-facets]').forEach((details) => {
    if (details.dataset.mobileFacetsBound === 'true') return;
    details.dataset.mobileFacetsBound = 'true';
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
    details.addEventListener('toggle', () => {
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
      if (details.open) {
        document.querySelectorAll('[data-mobile-facets][open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
        window.requestAnimationFrame(() => details.querySelector('.mobile-facets__close')?.focus());
      }
      document.body.classList.toggle('mobile-facets-open', Boolean(document.querySelector('[data-mobile-facets][open]')));
    });
  });
};

const closeMobileFacets = (details) => {
  if (!details) return;
  const summary = details.querySelector(':scope > summary');
  details.open = false;
  summary?.focus();
};

bindMobileFacets();

document.addEventListener('shopify:section:load', (event) => bindMobileFacets(event.target));

window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
  if (!event.matches) return;
  document.querySelectorAll('[data-mobile-facets][open]').forEach((details) => closeMobileFacets(details));
});
